"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenu = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Buttons = require("../Buttons");

var _Icon = require("../Icon");

var _Icons = require("../Icons");

var _Layout = require("../Layout");

var _Typography = require("../Typography");

var initialDropdownSpace = 8;
var StyledDropdownButton = (0, _styledComponents.default)(_Buttons.Button).withConfig({
  displayName: "DropdownMenu__StyledDropdownButton",
  componentId: "sc-1bj3o3m-0"
})({
  borderRadius: '50%',
  padding: '8px',
  position: 'relative'
});
var StyledDropdownIcon = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "DropdownMenu__StyledDropdownIcon",
  componentId: "sc-1bj3o3m-1"
})({
  transform: 'rotate(90deg)'
});
var StyledDropdownContent = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DropdownMenu__StyledDropdownContent",
  componentId: "sc-1bj3o3m-2"
})({
  cursor: 'default',
  position: 'absolute',
  zIndex: '9999'
}, (0, _styledSystem.variant)({
  prop: 'isOpen',
  variants: {
    false: {
      visibility: 'hidden'
    },
    true: {
      visibility: 'visible'
    }
  }
}));
var StyledDropdownOption = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "DropdownMenu__StyledDropdownOption",
  componentId: "sc-1bj3o3m-3"
})((0, _css.default)({
  minWidth: '168px',
  cursor: 'pointer',
  borderLeft: '4px solid',
  borderColor: 'transparent',
  paddingLeft: 2,
  marginLeft: '-12px',
  ':hover': {
    borderColor: 'rambutan',
    p: {
      fontWeight: '700'
    }
  }
}));

var DropdownMenu = function DropdownMenu(_ref) {
  var dropdownMenuOptions = _ref.dropdownMenuOptions;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpenState = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      bottomPosition = _useState4[0],
      setBottomPosition = _useState4[1];

  var dropdownButtonRef = (0, _react.useRef)();
  var dropdownOpenRef = (0, _react.useRef)(dropdownOpen);

  var setDropdownOpen = function setDropdownOpen(data) {
    dropdownOpenRef.current = data;
    setDropdownOpenState(data);
  };

  var handleDropdownContentRef = function handleDropdownContentRef(node) {
    if (node !== null) {
      dropdownButtonRef.current = node;
      setBottomPosition((node.getBoundingClientRect().height + initialDropdownSpace) * -1);
    }
  };

  var handleButtonClicked = function handleButtonClicked(event) {
    event.preventDefault();
    event.stopPropagation();
    setDropdownOpen(!dropdownOpenRef.current);
  };

  var handleDocumentClick = function handleDocumentClick(_ref2) {
    var _dropdownButtonRef$cu;

    var target = _ref2.target;

    if (!((_dropdownButtonRef$cu = dropdownButtonRef.current) !== null && _dropdownButtonRef$cu !== void 0 && _dropdownButtonRef$cu.contains(target)) && dropdownOpenRef.current === true) {
      setDropdownOpen(false);
    }
  };

  var handleDropdownContentClick = function handleDropdownContentClick(event) {
    event.preventDefault();
    event.stopPropagation();
  };

  var handleOptionClicked = function handleOptionClicked(event, onClick) {
    event.preventDefault();
    event.stopPropagation();
    setDropdownOpen(false);
    onClick(event);
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleDocumentClick);
    return function () {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, []);
  return _react.default.createElement(_Layout.Box, {
    position: "relative"
  }, _react.default.createElement(StyledDropdownButton, {
    forwardRef: dropdownButtonRef,
    buttonType: "text",
    backgroundColor: "coco",
    color: "guijarro",
    action: handleButtonClicked
  }, _react.default.createElement(StyledDropdownIcon, {
    size: "medium"
  }, _react.default.createElement(_Icons.Ellipsis, null))), _react.default.createElement(StyledDropdownContent, {
    borderRadius: 3,
    right: 0,
    paddingX: 6,
    paddingY: 5,
    backgroundColor: "coco",
    ref: handleDropdownContentRef,
    onClick: handleDropdownContentClick,
    isOpen: dropdownOpen,
    style: {
      bottom: "".concat(bottomPosition, "px")
    }
  }, _react.default.createElement(_Layout.Grid, {
    gridRowGap: 4
  }, dropdownMenuOptions.map(function (_ref3, index) {
    var label = _ref3.label,
        _onClick = _ref3.onClick;
    return _react.default.createElement(_Layout.GridItem, {
      gridRow: index + 1,
      key: "dropdown-menu-".concat(index + 1)
    }, _react.default.createElement(StyledDropdownOption, {
      onClick: function onClick(event) {
        return handleOptionClicked(event, _onClick);
      }
    }, _react.default.createElement(_Typography.Text, {
      size: "tiny"
    }, label)));
  }))));
};

exports.DropdownMenu = DropdownMenu;